import i18n from '~/common/helpers/i18n';

type AgentLogsTableStatsProps = {
  count: number;
  retentionValue: number | undefined;
  retentionUnit: string | undefined;
};

export function AgentLogsTableStats({
  count,
  retentionValue,
  retentionUnit
}: AgentLogsTableStatsProps) {
  return (
    <div className='mb-2.5 flex flex-col gap-0.5 pl-4'>
      <h1
        className='text-title-md'
        data-testid='monitor-agent-logs-heading-showing-data'
      >
        {i18n.t('scenes.monitor.agentLogs.table.executions_amount', {
          count
        })}
      </h1>
      <h2
        className='text-body-regular-md text-on-surface-variant'
        data-testid='monitor-agent-logs-heading-history-expires'
      >
        {i18n.t('scenes.monitor.logs.title.history_expires', {
          value: retentionValue,
          unit: retentionUnit
        })}
      </h2>
    </div>
  );
}
